export const environment = {
    production: false,
    staging: true,
    api: 'https://test.api.staff.asvz.ch/api',
    auth: 'https://test.api.staff.asvz.ch/auth',

    impersonation: {
        impersonationUserIdKey: 'StaffImpersonationUserId',
        allowedDomains: ['https://test.api.staff.asvz.ch'],
        endUrl: "https://test.admin.staff.asvz.ch/staff"
    },

    baseUrl: 'https://test.staff.asvz.ch',
    onlineDeskUrl: 'https://test.schalter.asvz.ch/tn',
    hangfireUrl: 'https://test.hangfire.staff.asvz.ch/dashboard',
    staffAdminUrl: 'https://test.admin.staff.asvz.ch',
    testEmailUrl: "http://test.schalter.asvz.ch:37408",
    pushNotifications: {
        vapidPublicKey: 'BIpsZPMkQPJXcgTZE0XRL1zTBbxQD6cmfy6RNMAlmIO7y8nTIT3wbYCmx0uYadYa5BAiLTLI1NTIzZ0wGv9lon4'
    },
    defaultEmailRecipients: [
      'info@asvz.ch'
    ]
};
